import React from 'react';

import { addMembersService } from '@mygpt/app/collaborate/services/add-members';
import { deleteMembersService, leaveMembersService } from '@mygpt/app/collaborate/services/delete-members';

export const useMembersMethods = () => {
  const [loading, setLoading] = React.useState(false);

  const add = React.useCallback(async (params: Parameters<typeof addMembersService>[0]) => {
    setLoading(true);
    return addMembersService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  const _delete = React.useCallback(async (params: Parameters<typeof deleteMembersService>[0]) => {
    setLoading(true);
    return deleteMembersService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  const leave = React.useCallback(async (params: Parameters<typeof leaveMembersService>[0]) => {
    setLoading(true);
    return leaveMembersService(params).finally(() => {
      setLoading(false);
    });
  }, []);

  return {
    loading,
    addMembers: add,
    deleteMembers: _delete,
    leaveMembers: leave,
  };
};
